import React from "react";

const EventTerms = () => {
  return (
    <div className="flex justify-center items-center w-full">
      <div className='flex flex-col gap-[80px] bg-offwhite md:max-w-[600px] lg:max-w-[950px] xl:max-w-[1400px] w-full overflow-x-hidden'>

        <p className="lg:text-[65px] text-[16px] font-chido">
          📜 Event Terms & Conditions
        </p>

        <div className='flex flex-col w-full lg:gap-10 gap-5'>
          <p className="lg:text-[65px] text-[16px] font-concretica">
            Accès et Sécurité
          </p>

          <p className="font-concretica lg:text-[32px] text-[14px]">
            - L’accès à l’événement est réservé aux détenteurs d’un billet valide
            ou d’une accréditation officielle.
            <br />- Toute personne entrant sur le site accepte d’être soumise à un
            contrôle de sécurité.
            <br />- Les objets interdits (drogues, armes, objets dangereux) seront
            confisqués.
          </p>
        </div>

        <div className='flex flex-col w-full lg:gap-10 gap-5'>
          <p className="lg:text-[65px] text-[16px] font-concretica">
            Comportement et Responsabilité
          </p>

          <p className="font-concretica lg:text-[32px] text-[14px]">
            - Le respect des autres participants, du personnel et des artistes est
            obligatoire.
            <br />- Tout comportement violent, discriminatoire ou inapproprié
            entraînera une expulsion immédiate sans remboursement.
            <br />- L’organisation n’est pas responsable des pertes ou vols
            d’objets personnels.
          </p>
        </div>

        <div className='flex flex-col w-full lg:gap-10 gap-5'>
          <p className="lg:text-[65px] text-[16px] font-concretica">
            Programme et Annulations
          </p>

          <p className="font-concretica lg:text-[32px] text-[14px]">
            - Le programme de l’événement est susceptible de modifications sans
            préavis.
            <br />- En cas d’annulation pour des raisons indépendantes de notre
            volonté (météo extrême, crise sanitaire, force majeure), aucun
            remboursement ne pourra être garanti.
          </p>
        </div>

        <div className='flex flex-col w-full lg:gap-10 gap-5'>
          <p className="lg:text-[65px] text-[16px] font-concretica">
            Utilisation d’Images et de Médias
          </p>

          <p className="font-concretica lg:text-[32px] text-[14px]">
            - En participant à l’événement, vous acceptez d’être potentiellement
            filmé ou photographié.
            <br />- L’organisation peut utiliser ces images à des fins
            promotionnelles sans compensation.
          </p>
        </div>

        <div className='flex flex-col w-full lg:gap-10 gap-5'>
          <p className="lg:text-[65px] text-[16px] font-concretica">
            Santé et Sécurité
          </p>

          <p className="font-concretica lg:text-[32px] text-[14px]">
            - Il est interdit d’introduire des substances illégales ou dangereuses.
            <br />- Un service médical est disponible sur place en cas de besoin.
          </p>
        </div>

      </div>
    </div>

  );
};

export default EventTerms;
